import React from 'react';
import { connect, useSelector } from 'react-redux';
import CreateUpdateContent from '../components/pages/meeting-room/create-update-view/content';

function MeetingRoomFormPage(props) {
  const groups = useSelector((state) => state.groupsReducer.meetingRoomGroups);
  const meetingRoomForm = useSelector((state) => state.meetingRoomReducer.meetingRoomForm);

  return (
    <div>
      <CreateUpdateContent groups={groups} meetingRoomForm={meetingRoomForm} updateOrInsert={props.updateOrInsert} />
    </div>
  );
}

export default MeetingRoomFormPage;
